import IReport from './IReport';
import generateCSV from "../../services/CSVController";
import save from 'save-file';
import { ICurrency } from "../../yoello-lib/modules/redux/actions/localization";
import { denominatorToFull } from '../../utils/rawPrice';
import { IStockReportItem } from './StockReport';

export default async function generateStockByAreaReportFile(stockReportArray: IStockReportItem[] | undefined, reportObj: IReport, currency: ICurrency,venueName:string) {
    /**If the stock report isn't undefined and the its greater than 0 try generate CSV */
    if (stockReportArray !== undefined && stockReportArray.length > 0) {
        const arrayOfKeys = ["table_area", "subcategory_name", "menu_item_name", "pricing_option_name", "item_selling_price", "quantity", "discount", "net_total", "vat", "total","venue_name","serial_id"];
        const arrayOfHeaders = ["Venue Area Name", "Subcategory name", "Item name", "Pricing name", "Item price", "Quantity", `Discount (${currency.iso_code})`, `Total Net (${currency.iso_code})`, `Tax (${currency.iso_code})`, `Total (${currency.iso_code})`,"Venue Name", "Venue ID"];
        const mapStockReport = stockReportArray.map((stockObject) => {
            return {
                subcategory_name: stockObject.subcategory_name,
                menu_item_name: stockObject.menu_item_name,
                pricing_option_name: stockObject.pricing_option_name,
                item_selling_price: denominatorToFull(stockObject.item_selling_price),
                quantity: stockObject.quantity,
                discount: denominatorToFull(stockObject.discount),
                vat: denominatorToFull(stockObject.vat),
                table_area: stockObject.table_area ? stockObject.table_area : "",
                total: denominatorToFull(stockObject.total),
                net_total: denominatorToFull(stockObject.total - stockObject.vat),
                venue_name:stockObject.venue_name,
                serial_id:stockObject.serial_id
            };
        });
        const csvString = generateCSV(mapStockReport, arrayOfKeys, arrayOfHeaders);
        save(csvString, `${
            venueName
        }-Item-sales-report-by-venue-area-from${
            reportObj.start_date_time
        }to${
            reportObj.end_date_time
        }.csv`);
        return;
    }
}